import { BaseLogin } from './login';
import guard from '@/guard';
import { ElLoading } from 'element-plus';

export class CloudLoginPage extends BaseLogin {
    async created() {
        guard.checkAuthentication();
        const loader = ElLoading.service({ lock: true });
        this.socials = await this.loginBloc.getSocial();
        loader.close();
    }

}

